<template>
  <div>
    <div class="private-container" v-show="!privateToursOnly" :style="edit ? 'background: #fff' : 'background: #EFF2F5'">
      <div v-if="edit">
        <div class="private-instructions text_style-bold">
          Choose experience type:
        </div>
        <div class="private-options">
          <div class="private-option" @click.prevent="updatePrivateTour(false)">
            <div class="option-cb">
              <radio-input :value="privateTour == false" />
            </div>
            <div class="option-title text_style-bold">
              Public
              <div class="option-subtitle text_size-medium-small text_style-def">
                Best for small groups to join other small groups.
              </div>
            </div>
          </div>
          <div class="private-option" @click.prevent="updatePrivateTour(true)">
            <div class="option-cb">
              <radio-input :value="privateTour == true" />
            </div>
            <div class="option-title text_style-bold">
              {{ privateTourRateName }}
              <div class="option-subtitle text_size-medium-small text_style-def">
                {{ privateTourRateDescription }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <a v-if="!edit" class="pt-summary" @click="handlePrivateSelector()">
        <div class="summary-title">
          {{ privateTour ? privateTourRateName : "Public" }}
        </div>
        <small class="text-blue">Edit</small>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
// import Loader from '../components/Loader.vue';
import RadioInput from "./RadioInput.vue";

export default {
  name: "PrivateUi",
  components: { RadioInput },
  props: ["value", "privateTourRateName", "privateTourRateDescription", "privateToursOnly"],
  data: function() {
    return {
      textVal: false,
      random: "toggle-" + Math.ceil(Math.random() * 100000000000000000),
      privateTour: null,
      edit: true,
    };
  },
  activated() {
    // if modifying, show selection
    if (this.$route.params.modify == "modify") {
      this.privateTour = this.value;
    }
  },
  beforeMount() {
    // if modifying, dont allow editing on mounting
    if (this.$route.params.modify == "modify") {
      this.edit = false;
    }
  },
  computed: {
    ...mapGetters(["activeProductDetails"]),
    ...mapState(["getTimesLoading"]),
  },
  methods: {
    updatePrivateTour(val) {
      this.privateTour = val;
      this.edit = false; // close private UI for editing
      this.$emit("privateSelection", this.privateTour);
    },
    // opens the private-ui slot for edit
    handlePrivateSelector() {
      this.edit = true;
    },
  },
};
</script>

<style lang="scss">
.private-container {
  border: 1px solid #d6dce6;
  border-radius: 4px;
  padding: 22px 15px;
  margin-bottom: 20px;
  user-select: none;
  height: fit-content;
}

.private-instructions {
  padding: 0 0 20px;
}

.private-options {
  display: grid;
  grid-gap: 20px;
}

.private-option {
  display: grid;
  grid-template-columns: 25px auto;
}

.option-cb {
  // display: grid;
  // place-items: center;
  // height: fit-content;
}

.option-title {
  margin-left: 16px;
  width: auto;

  :first-child {
    margin-top: 4px;
  }
}

.pt-summary {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.summary-title {
  font-size: 18px;
}
</style>
